import { userRoutes } from './users';
import { usMktRoutes } from './us-mkt';
import { teamRoutes } from './teams';
import { roleRoutes } from './roles';
import { bankRoutes } from './bank';

export const directoryRoutes = [
  {
    path: 'directory',
    children: [...userRoutes, ...usMktRoutes, ...teamRoutes, ...roleRoutes, ...bankRoutes],
  },
];
